import { render, staticRenderFns } from "./RoutePlanElementCardBody.vue?vue&type=template&id=bb423e9a&scoped=true"
import script from "./RoutePlanElementCardBody.vue?vue&type=script&lang=js"
export * from "./RoutePlanElementCardBody.vue?vue&type=script&lang=js"
import style0 from "./RoutePlanElementCardBody.vue?vue&type=style&index=0&id=bb423e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb423e9a",
  null
  
)

export default component.exports